import React, {useState, useEffect} from 'react';

import Page from '../../../components/Page';
import { Grid } from "../_Components/Grid";
import ComboBox2 from "../_Components/ComboBoxQuery";
import ComboBox from "../../component/ComboBox";
import { Row, Col, Input, Card, Modal, ModalHeader, ModalBody, Button, ButtonGroup, Label } from 'reactstrap';
import { Cookies } from 'react-cookie';

import DataAdapter from "../../adapter/DataAdapter";
import Task from "../Tasks/Task";
import TaskDetail		from "../TaskDetails/TaskDetail";
import Invoice		from "../Invoices/Invoice";


const cookie =new Cookies();

function FormScopeOfWorkManager (props){
	const [boardType, setBoardType]						= useState(0);
    const [projectId, setProjectId] 					= useState(-1);
    const [projectCategory, setProjectCategory] 		= useState('');
    const [parent, setParent] 							= useState(-1);
    const [receiver, setReceiver] 						= useState(-1);
    const [service, setService] 						= useState('');
    const [status, setStatus] 	= useState(-1);
    const [gridConfig, setGridConfig] 	= useState({});
    const [dataSource, setDataSource] 	= useState({});

	const loadGrid = (_projectId) =>{
							const _dataSource = {
								type 		: 	'table',
								table		:	'rb_project_tasks',
								fields		:	['pt_id', 'prj_id','parent','task_no','item_no','sort_id','is_show','task','task_type','duration','estimate_hours','item_qty','item_unit','item_price','estimate_cost','task_weight','receive_weight','receive_price','receiver_id','task_status','expected_start_date','expected_end_date'],
								getColumns	:	function(){
													var _columns	= [];
													this.fields.map(f=>_columns.push({id:f}));
													return _columns;
												},
								getRecords	:	async function(){
													var dataAdapter =new DataAdapter("SELECT pt.*, prj.prj_folder_id, IF(ISNULL(pt.task_weight*pt.percent_done),0,TRUNCATE(pt.task_weight*pt.percent_done/100,2)) AS `wd`, (SELECT IF(ISNULL(SUM(amount)),0, TRUNCATE(SUM(amount),2)) FROM rb_receive_n_payments WHERE pt_id = pt.pt_id AND rp_type=2) AS real_cost,(SELECT IF(ISNULL(SUM(amount)),0, TRUNCATE(SUM(amount),2)) FROM rb_receive_n_payments WHERE pt_id = pt.pt_id AND rp_type=1) AS received, ROUND(IF(ISNULL(SUM(ptd.real_cost)),0,SUM(ptd.real_cost)),2) AS not_due_cost,SUM(IF(ptd.Clock_out IS NULL OR ptd.Clock_out='0000-00-00 00:00:00', '0',ROUND(TIMESTAMPDIFF(MINUTE, ptd.Clock_in, ptd.Clock_out)*pr.emp_wage_amount/60,2))) AS `wage` FROM rb_project_tasks pt LEFT JOIN rb_projects prj ON prj.prj_id = pt.prj_id LEFT JOIN rb_project_task_details ptd ON ptd.pt_id = pt.pt_id LEFT JOIN rb_person pr ON pr.person_id = ptd.sender_id  WHERE pt.task_type Between 120 And 128 AND pt.prj_id=" + _projectId + " GROUP BY pt.pt_id ORDER BY pt.item_no, pt.sort_id;  ");
													return await dataAdapter.getRecords();
												},
								prepareUpdate:	[],
								onUpdate	:	async function(e, _primaryKey, _primaryValue, _field, _value){
													if(_primaryValue){
														var dataAdapter =new DataAdapter("UPDATE " + this.table + " SET " + _field + " = '" + _value + "' WHERE " + _primaryKey + " = '" + _primaryValue + "';");
														return await dataAdapter.getRecords();
													}else
													{
													}
												},
								prepareInsert:	[
								],
								onInsert	:	async function(e, _primaryKey, _record){
													var _sql	=	"";
													var _fields	=	"";
													var _values	=	"";
													Object.keys(_record).forEach((_key)=>{
														if(_key != _primaryKey){
															_fields += 	_key + ",";
															_values +=	"'" + _record[_key] + "',";
														}
													})
													_sql = "INSERT INTO " + this.table + " (" + _fields.slice(0, -1) + ") VALUES (" + _values.slice(0, -1) + ");";
													var dataAdapter =new DataAdapter(_sql + "\r\nSELECT " + _primaryKey + " FROM " + this.table + " ORDER BY " + _primaryKey + " DESC LIMIT 1;");
													return await dataAdapter.getRecords();
												},
								onCopy	:	async function(e, _primaryKey, _record){
													var _sql	=	"";
													var _fields	=	"";
													var _values	=	"";
													Object.keys(_record).forEach((_key)=>{
														if(_key != _primaryKey && this.fields.findIndex(f=>f==_key)!=-1){
															_fields += 	_key + ",";
															_values +=	"'" + _record[_key] + "',";
														}
													})
													_sql = "INSERT INTO " + this.table + " (" + _fields.slice(0, -1) + ") VALUES (" + _values.slice(0, -1) + ");";
													
													var dataAdapter =new DataAdapter(_sql + "\r\nSELECT " + _primaryKey + " FROM " + this.table + " ORDER BY " + _primaryKey + " DESC LIMIT 1;");
													return await dataAdapter.getRecords();
													
												},
								onDelete	:	async function(e, _primaryKey, _primaryValue){
													if(_primaryValue){
														var dataAdapter =new DataAdapter("DELETE FROM " + this.table + " WHERE " + _primaryKey + " = '" + _primaryValue + "';");
														return await dataAdapter.getRecords();
													}else
													{
													}
												},
							};
							const _gridConfig	=	{
								primaryKey	:	'pt_id',
								hasFilter	:	true,
								canDelete	:	true,
								canUpdate	:	true,
								canInsert	:	true,
								canCopy		:	true,
								group		:	[{by:"record['service_step']*1==0", parent:'parent'}],
								aggregations:	[{field:'estimate_cost',func:'sum'}, {field:'real_cost',func:'sum'}, {field:'received',func:'sum'}, {field:'not_due_cost',func:'sum'}, {field:'wd',func:'sum'}],
								actions		:	[{caption: 'Task',callback:(e)=>{ var _task =new Task(); _task.ViewTask(e);}}],
								columns		: [
									{id:'attachments', caption:'@', type:'formula', formula:"record['attachments']!='' && record['attachments']!=null && record['attachments']!='undefined'?'♣':''",hidden:false},
									{id:'is_show_in_web', caption:'Web', type:'checkbox',hidden:false},
									{id:'pt_id', caption:'Id', hidden:false, class:"text-vertical", width: '75px'},
									{id:'parent', caption:'parent', hidden:false, type:'text', defaultValue:'same', class:"text-vertical", width: '75px'},
									{id:'prj_id', caption:'Project', hidden:true, type:'text', defaultValue:'same', class:"text-vertical"},
									{id:'task_no', caption:'Task No.', type:'text' , hidden:true, class:"text-vertical"},
									{id:'item_no', caption:'Servic', type:'text', hidden:false, class:"text-vertical", width: '50px'},
									{id:'sort_id', caption:'Sort', type:'text', hidden:false, class:"text-vertical",width: '40px'},
									{id:'task', caption:'Task', type:'text', width: '300px'},
									{id:'task_type', hidden:false, caption:'Type', type:'select', queryString:"SELECT rb_type_no, rb_type_desc, rb_type_type_no FROM rb_types WHERE rb_type='task_type' AND rb_type_type_id=4;", valueField:'rb_type_no', displayField:'rb_type_desc',width: '150px'},
									{id:'duration', caption:'duration', type:'text', hidden:true, class:"text-vertical"},
									{id:'estimate_hours', caption:'Hours', type:'text', hidden:true, class:"text-vertical",width: '30px'},
									{id:'item_qty', caption:'Qty', type:'text', hidden:false, class:"text-vertical", hidden:true},
									{id:'item_unit', caption:'Unit', type:'select', queryString:"SELECT rb_types.rb_type_no, rb_types.rb_type_desc FROM rb_types WHERE (((rb_types.rb_type_id)=14));", valueField:'rb_type_no', displayField:'rb_type_desc', hidden:true},
									{id:'item_unit_price', caption:'Unit Price',type:'text', class:"text-vertical", hidden:true},
									{id:'item_price', caption:'Amount',type:'text', hidden:true},
									{id:'received', caption:'Received',type:'', prefix:'$', width:'75px', action:(e)=>{var _invoice	=new Invoice(); _invoice.viewReceiveAndPayment({prj_id:e['prj_id'], pt_id: e['pt_id']})}, hidden:true},
									{id:'receive_price', caption:'Payment Plan', hidden:true, prefix:'$', class:"text-vertical", hidden:true},
									{id:'receiver_id', caption:'Provid By', type:'select', queryString:"SELECT pr.person_id, pr.name, pt.pt_id FROM rb_project_tasks pt INNER JOIN rb_person pr ON pt.receiver_id = pr.person_id WHERE (((pt.prj_id)=" + _projectId + ")) GROUP BY pt.receiver_id; ", valueField:'person_id', displayField:'name',width: '120px', hidden:true},
									{id:'expected_start_date', caption:'Start',type:'date'},
									{id:'expected_end_date', caption:'End',type:'date'},
									{id:'task_weight', caption:'Weight',type:'text', hidden:false, class:"text-vertical",width: '30px'},
									{id:'estimate_cost', caption:'Budget', type:'text', formula:"record['item_qty']*record['item_unit_price']", prefix:'$', hidden:true},
									{id:'task_status', caption:'Status', hidden:false, type:'select', queryString:"SELECT rb_types.rb_type_no, rb_types.rb_type_desc FROM rb_types WHERE (((rb_types.rb_type_no) Between 6 And 10) AND ((rb_types.rb_type_id)=11)); ", valueField:'rb_type_no', displayField:'rb_type_desc',width: '120px'},
									{id:'percent_done', caption:'% Done',type:'text',width: '45px', class:"text-vertical"},
									{id:'real_cost', caption:'Cost (RnP)',type:'', prefix:'$', width:'75px', action:(e)=>{var _invoice	=new Invoice(); _invoice.viewReceiveAndPayment({prj_id:e['prj_id'], pt_id: e['pt_id']})}, class:"text-vertical", hidden:true},
									{id:'not_due_cost', caption:'Labor Cost (TD)',type:'', prefix:'$', width:'75px', action:(e)=>{var _taskDetail	=new TaskDetail(); _taskDetail.openProjectLogs({prj_id:e['prj_id'], pt_id: e['pt_id']}, 122);}, class:"text-vertical", hidden:true},
									{id:'wd', caption:'%',type:'', hidden:true},
								],
								rowClass	:	"(record['task_type']*1==125?'grid-section ':'small ')+(record['task_status']=='10'?'grid-bg-success':(record['task_status']=='9'?'bg-warning':(record['task_status']=='8'?'bg-info':'')))",
								//rowClass	:	"(record['sort_id']==0?'text-light bg-gray ':'')",

							};
							setGridConfig(_gridConfig);
							setDataSource(_dataSource);
							(new DataAdapter("SELECT * FROM rb_projects WHERE prj_id = " + _projectId)).getRecords().then(data=>{
								setProjectCategory(data[0].prj_category);
							})
		
	}

	useEffect(()=>{
		document.title="Scope Of Work Manager";
	},[]);

	const onQuoteSaveToWord = (e) => {
		let _name = "#" + projectId  + "-ScopeOfWork-" + (new Date()).toISOString().split('T')[0];

		var element = window.docx;
		var title = _name;
		if (!window.Blob) {
			alert('Your browser does not support');
			return;
		}

		var html, link, blob, url, css;

		css = (
			'<style>' +
			'@page WordSection1{size: 210mm 297mmt;mso-page-orientation: portrait;}' +
			'div.WordSection1 {page: WordSection1;}' +
			'* {font-family: Poppins,Tahoma,Arial,sans-serif;}' +
			'.wrapper {width:70%;text-align:center;margin:100px auto;}' +
			'.valid_box {width:100%;border-collapse: collapse;border-width: 1px;}' +
			'table {width: 100%; border: none;}' +
			'table thead th, table th {font-size:12px;color: #ffffff;background-color: gray;border-color: #000;border-style:solid;border-width: 1px;}' +
			'table thead th, table tbody td, table th, table td {font-size:12px;padding: 5px;border-collapse: collapse;border-style:solid;border-width: 1px;}' +
			'.report-header{border: none;}' +
			'</style>'
		);

		html = element.innerHTML;
		blob = new Blob(['\ufeff', css + html], {
			type: 'application/msword'
		});
		url = URL.createObjectURL(blob);
		link = document.createElement('A');
		link.href = url;
		link.download = title;  // default name without extension 
		document.body.appendChild(link);
		if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, title + '.doc'); // IE10-11
		else link.click();  // other browsers
		document.body.removeChild(link);

	}

	return (
		<>
			<Page title="Scope Of Work Manager" breadcrumbs={[{ name: 'Project Management', active: true }]}>
			<Row className="p-1">
				<Col md={6} sm={12} xs={12} >
					<Button color="secondary" className="btn btn-block" onClick={(e)=>{
						e.persist();
						var _task =new Task();
							_task.ViewScopeOfWork(projectId);
					}} >Preview</Button>
				</Col>
				<Col md={6} sm={12} xs={12} >
					<Button color="secondary" onClick={(e) => { 
						var _queryString	="UPDATE rb_project_tasks pt SET pt.expected_start_date= (SELECT MIN(start_date) FROM rb_project_task_details WHERE task_type=122 AND pt_id=pt.pt_id), pt.expected_end_date= (SELECT MAX(start_date) FROM rb_project_task_details WHERE task_type=122 AND pt_id=pt.pt_id) where pt.prj_id = " + projectId + ";";
						(new DataAdapter(_queryString)).getRecords().then(responseData=>{
							loadGrid(projectId);
						})
					}} >Update Plan</Button>{' '}
				</Col>
			</Row>
			
			<Row className="p-1">
				<Col md={2} sm={2} xs={2} >
					<ButtonGroup className="mr-3 mb-3">
						<Button color={boardType==0?"primary":"light"} onClick={(e)=>{setBoardType(0);}} >Internal</Button>
						<Button color={boardType==1?"primary":"light"} onClick={(e)=>{setBoardType(1);}} >External</Button>
					</ButtonGroup>
				</Col>
				<Col md={4} sm={4} xs={4} >
					<ComboBox title="Project Status" onChange={async (e)=>{
						e.persist();
						setStatus(e.target.value);
						setProjectId(-1);
					}} table="rb_types" filterField="rb_type" filterValue={'prj_status'} valueField="rb_type_no" displayField="rb_type_desc"  orderby="rb_type_no" />
				</Col>
				<Col md={6} sm={6} xs={6} >
					{boardType==0?
						<ComboBox title="Projects" onChange={async (e)=>{
							loadGrid(e.target.value);
							setProjectId(e.target.value);
						}} table="rb_projects" filterField="prj_status" filterValue={"23' AND prj_code IN (SELECT distinct rb_type_caption FROM rb_types WHERE rb_type='task_type' AND rb_type_caption <> '') AND 'x'='x"} valueField="prj_id" displayField="prj_code,prj_title"  orderby="prj_id" defaultValue={projectId} />
					:
						<ComboBox title="Projects" onChange={async (e)=>{
							loadGrid(e.target.value);
							setProjectId(e.target.value);
						}} table="rb_projects" filterField="prj_status" filterValue={status + "' AND prj_department IN (SELECT rb_type_no FROM rb_types WHERE rb_type='prj_department' AND rb_type_type_id=1 AND rb_type_type_no<>0) AND 'x'='x" } valueField="prj_id" displayField="prj_id,prj_address"  orderby="prj_id" defaultValue={projectId} />
					}
				</Col>
			</Row>
			<Row className="p-1">
				<Col md={3} sm={3} xs={3} >
					<ComboBox title="Services" onChange={async (e)=>{
						setService(e.target.value);
					}} table="rb_services" filterField="service_step" filterValue={"-1"} valueField="service_no" displayField="service_item"  orderby="service_item" />
				</Col>
				<Col md={2} sm={2} xs={2} >
					<ComboBox2 title="Provide By" onChange={async (e)=>{
						setReceiver(e.target.value.split(',')[0]);
						setParent(e.target.value.split(',')[1]);
					}} queryString={"SELECT rb_person.person_id, rb_person.name, rb_project_tasks.pt_id, rb_project_tasks.task_type FROM rb_project_tasks INNER JOIN rb_person ON rb_project_tasks.receiver_id = rb_person.person_id WHERE (((rb_project_tasks.task_type)=9 Or (rb_project_tasks.task_type)=91 OR (rb_project_tasks.task_type)=92) And ((rb_project_tasks.prj_id)=" + projectId + "));"}
					valueField="person_id,pt_id" displayField="name"  />
				</Col>
				<Col md={3} sm={3} xs={3} >
					<Input className="btn btn-primary" type="button" value="Add This Service To The Plan" onClick={(e)=>{
						var _queryString	=	"INSERT INTO rb_project_tasks ( prj_id, parent, task_no, task, item_unit, item_price, duration, item_value, task_type, item_no, task_status, receiver_id, sender_id, quote_no, sort_id, is_show, start_date, end_date )" +
												" SELECT " + projectId + " AS prj_id, " + parent + " AS parent, rb_services.service_id, rb_services.service_item, rb_services.service_unit, rb_services.service_unit_price, rb_services.service_duration, rb_services.service_type, rb_types.rb_type_no, rb_services.service_no, 7 AS task_status, " + receiver + " AS receiver_id, 0 AS sender_id, '24-Q-" + projectId + "-R3' AS Quote_no, rb_services.sort_id, rb_services.is_show, now(), now()" + 
												" FROM rb_services INNER JOIN rb_types ON rb_services.service_type = rb_types.rb_type_no" +
												" WHERE (((rb_types.rb_type_type_id)=4) AND ((rb_services.service_step)>=0) AND rb_services.service_no='" + service + "');";
						(new DataAdapter(_queryString)).getRecords().then(responseData=>{
							loadGrid(projectId);
						})
					}} />
				</Col>
				<Col md={3} sm={3} xs={3} >
					<Input className="btn btn-primary" type="button" value="Insert New Service To The Plan" onClick={async(e)=>{
						const	_task 		=new Task();
						var 	_response	=	await _task.openScopeOfWorks(projectId, parent, receiver);
								loadGrid(projectId);

					}} />
				</Col>
				<Col md={3} sm={3} xs={3} >
					<Input className="btn btn-primary" type="button" value="View/Edit Services" onClick={async(e)=>{

					}} />
				</Col>
			</Row>
			<Row className="p-1">
				<Col md={12} sm={12} xs={12} >
					<div id="docx" >
						<Grid config={gridConfig} dataSource={dataSource} callback={(e)=>{}} collaps={true} />
					</div>
				</Col>
			</Row>
			</Page>
		</>
	);
}

export default FormScopeOfWorkManager;


